import { put, call, takeLatest, select } from 'redux-saga/effects';
import FileSaver from 'file-saver';
import _ from 'lodash';

import { request, pagableRequest } from 'api';
import { getFilterParams, showMessage } from 'utils/helpers';
import { TYPE, ACTION } from './actions';
import * as selectors from './selectors';

function* fetchRemaindersReportHandler({ payload = {} }) {
    try {
        const filters = yield select(selectors.filters);

        yield put(ACTION.fetchRemaindersReportLoading());

        const res = yield call(pagableRequest(payload), {
            url: 'reports/client-balance',
            params: getFilterParams(filters)
        });

        yield put(ACTION.fetchRemaindersReportSuccess(res.data));
    } catch (err) {
        yield put(ACTION.fetchRemaindersReportError(err));
        console.error(err);
    }
}

function* fetchTotalRemaindersHandler() {
    try {
        const filters = yield select(selectors.filters);

        yield put(ACTION.fetchRemaindersReportLoading());

        const res = yield call(request, {
            url: 'reports/total-client-balance',
            params: getFilterParams(filters)
        });

        yield put(ACTION.fetchTotalRemaindersSuccess(res.data));
    } catch (err) {
        yield put(ACTION.fetchTotalRemaindersError(err));
        console.error(err);
    }
}

function* exportToExcel() {
    try {
        const filters = yield select(selectors.filters);
        showMessage({ type: 'warning', message: 'Почалося завантаження звіту - це може зайняти деякий час.' });

        const res = yield call(request, {
            responseType: 'arraybuffer',
            url: 'reports/client-balance/export',
            params: getFilterParams(filters),
        });

        const contentDisposition = _.get(res, 'headers.content-disposition', 'filename=report.xls');
        const [, filename] = contentDisposition.match(/filename=(.*)/);

        const blob = new Blob([res.data], { type: 'text/plain;charset=utf-8' });
        FileSaver.saveAs(blob, filename);
    } catch (err) {
        console.log(err);
    }
}

export default [
    takeLatest(TYPE.FETCH_REMAINDERS_REPORT, fetchRemaindersReportHandler),
    takeLatest(TYPE.FETCH_TOTAL_REMAINDERS, fetchTotalRemaindersHandler),
    takeLatest(TYPE.EXPORT_TO_EXCEL, exportToExcel),
];
